<template>
  <div class="segmented-progress-bar__wrapper">
    <div
      v-for="(step, index) in steps"
      :class="['segment', { 'uncompleted': stepNotCompleted(index) }]"
      :style="style"
      :key="index"/>
  </div>
</template>
<script>
export default {
  // Passing segment height and width as props makes this component more reusable
  name: "SegmentedProgressBar",
  props: {
    segmentHeight: {
      type: Number,
      required: true
    },
    segmentWidth: {
      type: Number,
      required: true
    },
    segmentMargin: {
      type: Number,
      default: 2
    },
    steps: {
      type: Number,
      required: true
    }
  },
  computed: {
    activeStepNumber() {
      return this.$store.getters["navigation/activeStepNumber"];
    },
    style() {
      return {
        height: `${this.segmentHeight}px`,
        marginLeft: `${this.segmentMargin}px`,
        width: `${this.segmentWidth}px`
      };
    }
  },
  methods: {
    stepNotCompleted(index) {
      return index > this.activeStepNumber - 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.segment {
  background-color: currentColor;

  &.uncompleted {
    opacity: 0.4;
  }
  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin-left: 0 !important;
  }
  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
